export const ACCOUNT_PHONE_VERIFY_GENERATE = 'ACCOUNT_PHONE_VERIFY_GENERATE'
export const ACCOUNT_PHONE_VERIFY_REGENERATE = 'ACCOUNT_PHONE_VERIFY_REGENERATE'
export const ACCOUNT_PHONE_VERIFY_CONFIRM = 'ACCOUNT_PHONE_VERIFY_CONFIRM'
export const ACCOUNT_PHONE_VERIFY_ERROR = 'ACCOUNT_PHONE_VERIFY_ERROR'
export const ACCOUNT_PHONE_VERIFY_PROGRESS = 'ACCOUNT_PHONE_VERIFY_PROGRESS'

export function updatePhoneVerifyProgress(payload = {}) {
  return {
    type: ACCOUNT_PHONE_VERIFY_PROGRESS,
    payload,
  }
}

export function generatePhoneVerifyCode(payload = {}) {
  return {
    type: ACCOUNT_PHONE_VERIFY_GENERATE,
    payload,
  }
}

export function regeneratePhoneVerifyCode(payload = {}) {
  return {
    type: ACCOUNT_PHONE_VERIFY_REGENERATE,
    payload,
  }
}

export function confirmPhoneVerifyCode(payload = {}) {
  return {
    type: ACCOUNT_PHONE_VERIFY_CONFIRM,
    payload,
  }
}

export function errorPhoneVerify(payload = {}) {
  return {
    type: ACCOUNT_PHONE_VERIFY_ERROR,
    payload,
  }
}
